module.exports = __webpack_public_path__ + "img/handelsbanken-logo.f3590b2f.svg";